module.exports = __webpack_public_path__ + "img/tapak-semaian-kelapa-tacunan-3.5edfcf63.jpeg";